import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { ReportOptions } from '../../models/report-options';
import { User } from '../../models/user';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  currentDomain = environment.currentApiHostname
  apiUrl = `https://${this.currentDomain}/api/general`;


  constructor(private http: HttpClient) {
  }

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
      `/users?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  indexByAhfozNumber(
    ahfozNumber: string,
    paginationOptions: PaginationOptions,
  ) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
      `/users/index/providers/${ahfozNumber}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  indexByCompanyNumber(
    companyNumber: string,
    paginationOptions: PaginationOptions,
  ) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
      `/users/index/companies/${encodeURIComponent(
        companyNumber
      )}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<User>>(
      this.apiUrl + `/users/index/all`,
      options
    );
  }

  updateUserPassword(user: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<User>(
      this.apiUrl + `/users/change-user-password/${uuid}`,
      user,
      options
    );
  }

  setPassword(uuid: string, payload: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<User>(
      this.apiUrl + `/users/set-password/${uuid}`,
      payload,
      options
    );
  }

  sendPasswordResetEmail(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<User>(
      this.apiUrl + `/users/send-password-reset-email/${uuid}`,
      options
    );
  }


  sendUserInviteEmail(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<User>(
      this.apiUrl + `/users/send-user-invite-email/${uuid}`,
      options
    );
  }

  inventoryStatement(uuid: string, reportOptions: ReportOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<any>(
      this.apiUrl +
      `/users/inventory/statement/${uuid}?${ReportOptions.getReportQueryParameters(
        reportOptions
      )}`,
      options
    );
  }

  getSalespersons() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<User>>(
      this.apiUrl + `/users/role/salesperson`,
      options
    );
  }

  getUsersWithPermission(section: string, permission: number) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<User>>(
      this.apiUrl + `/users/with-permission/${section}/${permission}`,
      options
    );
  }


  logs(
    uuid: string,
    paginationOptions: PaginationOptions,
    reportOptions: ReportOptions
  ) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
      `/users/logs/${uuid}?page=${paginationOptions.pageNumber}&perPage=${paginationOptions.perPage}&sort=${paginationOptions.sort}&direction=${paginationOptions.direction}&?startDate=${reportOptions.startDate}&endDate=${reportOptions.endDate}`,
      options
    );
  }

  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<User>(this.apiUrl + `/users/${uuid}`, options);
  }

  store(user: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<User>(this.apiUrl + `/users`, user, options);
  }

  update(user: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<User>(this.apiUrl + `/users/update/${uuid}`, user, options);
  }

  uploadAvatar(uuid: string, file: Blob) {
    const formData = new FormData();
    formData.append('avatar_file', file, 'avatar.png');
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };
    return this.http.post<User>(this.apiUrl + `/users/avatar/${uuid}`, formData, options);
  }


  updatePassword(user: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<User>(
      this.apiUrl + `/users/password/update`,
      user,
      options
    );
  }

  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserPayments(
    uuid: string,
    type: string,

    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/payments/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserReceipts(
    uuid: string,
    type: string,

    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/receipts/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserWithdrawals(
    uuid: string,
    type: string,

    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/withdrawals/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserDeposits(
    uuid: string,
    type: string,
    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/deposits/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserSalesOrders(
    uuid: string,
    type: string,

    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/sales-orders/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserSalesReturns(
    uuid: string,
    type: string,

    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/sales-returns/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserRideNotes(
    uuid: string,
    type: string,

    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/ride-notes/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserContactPersons(
    uuid: string,
    type: string,

    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/contact-persons/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserQuotations(
    uuid: string,
    type: string,

    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/quotations/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }

  exportUserInvoices(
    uuid: string,
    type: string,

    paginationOptions: PaginationOptions
  ) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
      `/exports/users/${uuid}/invoices/export/${type}?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }
}
